/**
 * This is the main axios handler, where is configured to handle
 * all the incoming and upconfimg requests
 */

import { getObject, getCookie } from '@/helpers/storage'
import { URL } from '@/constants'
import { refreshToken } from '@/api'
import moment from 'moment'

const untokenedURLs = ['/api/auth/login'];
/**
 * implemented at ~/main.js
 */
export default ({ store, router, vue, axios, lang }) => {

    axios.defaults.baseURL = URL;

    /**
     * the config must always be returned
     * @description this function is called after the request is sent
     * @return {JSON} config
     * @throws {Response} error
     */
    axios.interceptors.response.use(response => {
        /**
         * the const user is called here because the user must be requested
         * at every request to confirm its current state, if is declared outside
         * the interceptors then the user will be declared just at the app initialization
         */
        const user = getObject('session');

        /**
         * this block verifies everytime the route changes if the current date
         * is between 10 minutes with the expiration date to refresh the token
         */
        if (user && localStorage.getItem(process.env.VUE_APP_USER_TOKEN_NAME)) {
            const format = 'YYYY-MM-DD HH:mm';
            let expiration_date_cookie = localStorage.getItem(process.env.VUE_APP_USER_TOKEN_EXPIRATION_DATE);
            let expire_at = moment(expiration_date_cookie, format);
            let expire_interval = moment(expiration_date_cookie, format).subtract(10, 'm');

            if (!moment().isBetween(expire_interval, expire_at)) {
                return response
            }

            if (!(response.config.url === `${URL}/api/auth/refresh-token`)) {
                
                refreshToken()
                    .then(res => {
                        store.dispatch('session/refreshToken', res);
                        return response
                    }).catch(() => {
                        router.push({ name: 'login' });
                        return response
                    })
            }
        }

        return response
    }, error => { // something wrong happend
        /**
         * to start the axios request validation we must start validating
         * that the response is readable, if its readable we can proceed
         * to read the status codes.
         */
        if (error.hasOwnProperty('response')) {
            
            switch (error.response.status) {
                case 500:
                    vue.prototype.$message.error(lang.messages.errors.internal_server_error);
                    break;
                case 400:
                    if (error.response.data.hasOwnProperty('error')) {
                        try {
                            if (error.response.data.error[0] === 'Token is Invalid' || error.response.data.error[0] === 'Token is Expired') {
                                vue.prototype.$message.error(lang.messages.errors.expired_session);
                                store.dispatch('session/vanish')
                            }
                        } catch (err) {
                            store.dispatch('session/vanish')
                        }
                    }
                    break;
                case 401:
                    vue.prototype.$message.error(lang.messages.errors.authentication);
                    break;
                case 404:
                    vue.prototype.$message.error(lang.messages.errors.route_not_found);
                    break;
                case 405:
                    vue.prototype.$message.error(lang.messages.errors.http_method_not_found);
                    break;
                case 422:
                    store.dispatch('setErrors', error.response.data.errors);
                    break;
                default: console.log('unhandled error, status code =>', error.response.status)
            }
        }
        return Promise.reject(error);
    });

    /**
     * the config must always be returned
     * @description this function is called before send the request to the server
     * @return {JSON} config
     * @throws {Response} error
     */
    axios.interceptors.request.use(config => {
        const user = getObject('session');
        const token = localStorage.getItem(process.env.VUE_APP_USER_TOKEN_NAME);
        if (user && !untokenedURLs.includes(config.url)) {
            config.headers['Authorization'] = `Bearer ${token}`
        }
        let encoded = encodeURI(config.url);
        config.url = encoded;

        return config
    }, error => Promise.reject(error))
}